import type { PlcManufacturerCodeLibrary } from "./types";

export const ls_electricCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "ls-electric",
  manufacturer_name: "LS ELECTRIC",
  codes: [
    {
      id: "ls-xgb-watchdog-error",
      manufacturer_id: "ls-electric",
      series_id: "ls-xgb",
      model: null,
      code: "WATCH-DOG TIMER ERROR",
      code_type: "System Error",
      title_ar: "XGB Watch-dog Timer Error",
      description_ar: "دليل XGB يذكر Watch-dog Timer Error كمثال على System Error يكتشفه الـCPU.",
      symptoms: ["الـPLC يوقف التشغيل للحماية", "المخارج تنطفئ حسب سلوك خطأ النظام"],
      causes: ["زمن تنفيذ/برنامج غير طبيعي", "خلل بالنظام"],
      checks: [
        {
          step: 1,
          action: "راجع XG5000 diagnostics ووقت تنفيذ البرنامج.",
          expected: "ماكو system error والـscan طبيعي.",
          faulty: "Watch-dog error يظهر بالتشخيص.",
        }
      ],
      solutions: ["عالج منطق البرنامج أو الحمل على الـCPU.", "راجع XG5000 User Manual للتشخيص التفصيلي."],
      severity: "حرجة",
      source_title: "LS ELECTRIC XGB Main Unit User Manual",
      source_section: "System error example: watch-dog timer error",
      keywords: ["LS ELECTRIC", "XGB", "watchdog", "system error"],
    },
    {
      id: "ls-xgb-module-installation-error",
      manufacturer_id: "ls-electric",
      series_id: "ls-xgb",
      model: null,
      code: "MODULE INSTALLATION ERROR",
      code_type: "System Error",
      title_ar: "XGB Module Installation Error",
      description_ar: "دليل XGB يذكر Module Installation Error ضمن أخطاء النظام الممكن اكتشافها.",
      symptoms: ["الـPLC يوقف أو يمنع التشغيل الطبيعي", "موديول مو مقبول بالتكوين"],
      causes: ["موديول مركب بصورة غير صحيحة", "تكوين الموديولات مو مطابق"],
      checks: [
        {
          step: 1,
          action: "افصل التغذية قبل فحص تثبيت الموديولات، وبعدها قارن التكوين بـXG5000.",
          expected: "الموديولات مثبتة ومتطابقة.",
          faulty: "موديول غير مثبت أو غير مطابق.",
        }
      ],
      solutions: ["ثبت الموديول بصورة صحيحة بعد العزل.", "صحح التكوين أو استبدل الموديول إذا متضرر."],
      severity: "حرجة",
      source_title: "LS ELECTRIC XGB Main Unit User Manual",
      source_section: "System error example: module installation error",
      keywords: ["LS ELECTRIC", "XGB", "module installation", "system error"],
    },  ],
};
